import { POPUP_KEY_CREATE_FORM, PRODUCT_CATEGORY_ANY, PRODUCT_FORM_LIQUID } from "../constant";
import i18n from "../i18nService";
import { formsService } from "./formsService";
import { formsStorage } from "./formsStorage";
import { productsStorage } from "./productsStorage";
import { recipeSaveService } from "./recipeSaveService";

const findProductByProductCode = (productCode) => {
    return productsStorage.getItems(true).find(it => it.productCode === productCode) || {};
};

const filterFormsList = (form, productCode) => {
    const productCategory = findProductByProductCode(productCode).productCategory;
    return (productCategory && form.formGroup === productCategory)
        || form.formGroup === PRODUCT_CATEGORY_ANY
        || form.formGroup === PRODUCT_FORM_LIQUID
        || productCategory === null;
};


const transformFormsList = (formsList, productCode, withFilter, i18nInstance = i18n) => {
    let resultArray = [];
    withFilter ? formsList = formsList.filter(it => filterFormsList(it, productCode)) : null;
    formsList.forEach(it => resultArray.push({
        itemId: it.id,
        itemTitle: formsService.getLocalization(i18nInstance.resolvedLanguage, it, true, i18nInstance),
        included: true,
        code: it.productForm,
    }));
    return resultArray;
};

export class formsIngredientService  {
    observersList = [];
    filter = '';
    productCode = '';
    ingredientId = '';

    constructor (productCode, ingredientId) {
        this.productCode = productCode;
        this.ingredientId = ingredientId;
    }

    getPossibleItems(i18nInstance = i18n) {
        return transformFormsList(
            formsStorage.getItems(true)
                .filter((it) => it.formType === 'product-part')
                .filter(it => formsService.getLocalization(i18nInstance.resolvedLanguage, it, true, i18nInstance).toLowerCase().includes(this.filter.toLowerCase())), this.productCode,
            true,
            i18nInstance
        );
    }

    getCurrentItems(i18nInstance = i18n) {
        const forms = recipeSaveService.getRecipe().ingredient
            .find(ingredient => ingredient.id === this.ingredientId)?.ingredientParts[0]?.ingredientForms || [];
        return forms
            .filter((it) => it.formType !== 'heatTreatment')
            .map(it => {
                return {
                    itemId: it.id,
                    itemTitle: formsService.getLocalization(i18nInstance.resolvedLanguage, it.formCode, true, i18nInstance),
                    included: true,
                    code: it.formCode,
                };
            });
    }

    getPlaceHolder() {
        return "";
    }

    deleteItem(formId) {        
        recipeSaveService.deleteIngredientForm(this.ingredientId, this.getPossibleItems().find(it => it.itemId === formId).code);
        this.notifyItemsChangingObservers();
    }

    addItem(formId, included) {
        recipeSaveService.addIngredientForm(this.ingredientId, this.getPossibleItems().find(it => it.itemId === formId));
        this.notifyItemsChangingObservers();
    }

    registerItemsChangingObserver(observer) {
        this.observersList.push(observer);
    }

    unRegisterItemsChangingObserver(observer) {
        try {
            this.observersList = this.observersList.filter(observerItem => observerItem !== observer);
        } catch (err) {
            console.log(err);
        }
    }

    notifyItemsChangingObservers() {
        this.observersList.forEach(observer => observer());
    }

    hasExcludedItemsBlock() {
        return false;
    }

    setSearchFilterValue(searchValue) {
        this.filter = searchValue;
        this.notifyItemsChangingObservers();
    }

    getSearchString() {
        return this.filter;
    }

    isSearchStringChanged() {
        return true;
    }

    handleSearchFilterValue() {}

    getPopupKey() {
        return POPUP_KEY_CREATE_FORM;
    }

    getButtonTitle(i18nInstance = i18n) {
        return i18nInstance.t("app.page.product.addForm");
    }

    getLabelName(i18nInstance = i18n) {
        return i18nInstance.t('app.page.recipe.ingredientForm');
    }
}

export const createFormsIngredientService = (productCode, ingredientId) => {
    return new formsIngredientService(productCode, ingredientId);
};
